// material icon
import AddIcon from '@material-ui/icons/Add';
import ShopIcon from '@material-ui/icons/Shop';
import ViewListIcon from '@material-ui/icons/ViewList';
import EditIcon from '@material-ui/icons/Edit';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AppsIcon from '@material-ui/icons/Apps';
import PeopleIcon from '@material-ui/icons/People';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssessmentIcon from '@material-ui/icons/Assessment';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import UpdateIcon from '@material-ui/icons/Update';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import PieChartIcon from '@material-ui/icons/PieChart';
import EventIcon from '@material-ui/icons/Event';
import WorkIcon from '@material-ui/icons/Work';
import PolicyIcon from '@material-ui/icons/Policy';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Note from '@material-ui/icons/Note'
// configs
import { PATH_NAME, DRAWER_MENU_LABEL, USER_ROLE } from 'configs';
import canAction from 'helpers/canAction';

const isStateUser =
  localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).roleUser === USER_ROLE.STATE_COMMISSIONER;

// Function to check if Master menu should be visible
const shouldShowMasterMenu = () => {
  return (
    canAction('view', DRAWER_MENU_LABEL.USER_MASTER) ||
    canAction('view', DRAWER_MENU_LABEL.USER_STATE_PENDING) ||
    canAction('view', DRAWER_MENU_LABEL.CATEGORY_MASTER) ||
    canAction('view', DRAWER_MENU_LABEL.SUB_CATEGORY_MASTER)
  );
};

export const getNavBarCommon = () => [
  // {
  //   subheader: 'Application',
  //   items: [
  //     {
  //       title: 'Report',
  //       href: PATH_NAME.DASHBOARD,
  //       icon: DashboardIcon,
  //       label: DRAWER_MENU_LABEL.DASHBOARD,
  //     },
  //     {
  //       title: 'Playbackground',
  //       href: PATH_NAME.PLAY_BACKGROUND,
  //       icon: SportsEsportsIcon,
  //       label: DRAWER_MENU_LABEL.PLAY_BACKGROUND,
  //     },
  //   ],
  // },
  {
    subheader: 'Sugamya Panel',

    items: [
      {
        title: 'Dashboard',
        icon: DashboardIcon,
        href: PATH_NAME.DASHBOARD,
        label: DRAWER_MENU_LABEL.DASHBOARD,
      },
      ...(shouldShowMasterMenu()
        ? [
            {
        title: 'Master',
        icon: AssessmentIcon,
        href: PATH_NAME.MASTER,
        label: DRAWER_MENU_LABEL.MASTER,
        items: [
          // {
          //   title: 'Country Master',
          //   icon: RadioButtonUncheckedIcon,
          //   href: PATH_NAME.COUNTRY_MASTER_LIST,
          //   label: 'COUNTRY MASTER',
          // },
          // {
          //   title: 'State Master',
          //   icon: RadioButtonUncheckedIcon,
          //   href: PATH_NAME.STATE_MASTER_LIST,
          //   label: DRAWER_MENU_LABEL.PRODUCT_ADD,
          // }
          // {
          //   title: 'District Master',
          //   icon: RadioButtonUncheckedIcon,
          //   href: PATH_NAME.DISTRICT_MASTER_LIST,
          //   label: DRAWER_MENU_LABEL.PRODUCT_LIST,
          // },
          // {
          //   title: 'Sub-District Master',
          //   icon: RadioButtonUncheckedIcon,
          //   href: PATH_NAME.SUB_DISTRICT_MASTER_LIST,
          //   label: DRAWER_MENU_LABEL.PRODUCT_LIST,
          // },
                ...(canAction('view', DRAWER_MENU_LABEL.USER_MASTER)
                  ? [
                      {
            title: 'User Master',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.USER_MASTER_LIST,
            label: DRAWER_MENU_LABEL.USER_MASTER,
                      },
                    ]
                  : []),
                ...(canAction('view', DRAWER_MENU_LABEL.USER_STATE_PENDING)
                  ? [
                      {
            title: 'District Users',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.USER_PENDING_SC_LIST,
            label: DRAWER_MENU_LABEL.USER_STATE_PENDING,
                      },
                    ]
                  : []),
          // {
          //   title: 'Pending Users',
          //   icon: RadioButtonUncheckedIcon,
          //   href: PATH_NAME.USER_PENDING_ADMIN_LIST,
          //   label: DRAWER_MENU_LABEL.USER_ADMIN_PENDING,
          // },
                ...(canAction('view', DRAWER_MENU_LABEL.CATEGORY_MASTER)
                  ? [
                      {
            title: 'Sector Master',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.CATEGORY_MASTER_LIST,
            label: DRAWER_MENU_LABEL.CATEGORY_MASTER,
                      },
                    ]
                  : []),
                ...(canAction('view', DRAWER_MENU_LABEL.SUB_CATEGORY_MASTER)
                  ? [
                      {
            title: 'Sub Sector Master',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.SUB_CATEGORY_MASTER_LIST,
            label: DRAWER_MENU_LABEL.SUB_CATEGORY_MASTER,
                      },
                    ]
                  : []),
          /*   {
            title: 'Department Master',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.DEPARTMENT_MASTER_LIST,
            label: DRAWER_MENU_LABEL.DEPARTMENT_MASTER,
          }, */
          /*   {
            title: 'Designation Master',
            icon: RadioButtonUncheckedIcon,
            href: PATH_NAME.DESIGNATION_MASTER_LIST,
            label: DRAWER_MENU_LABEL.DESIGNATION_MASTER,
          }, */
              ].filter((item) => item), // Remove any undefined items
            },
          ]
        : []),
      // {
      //   title: 'Complaint Assignment',
      //   icon: FileCopyIcon,
      //   href: PATH_NAME.COMPLAINT_ASSIGNMENT,
      //   label: DRAWER_MENU_LABEL.PRODUCT,
      //   items: [
      //     {
      //       title: 'Assignment Master',
      //       icon: RadioButtonUncheckedIcon,
      //       href: PATH_NAME.ASSIGNMENT_MASTER_LIST,
      //       label: DRAWER_MENU_LABEL.PRODUCT_ADD,
      //     },
      //   ],
      // },
      /*  {
        title: 'Complaint Assignment',
        icon: WarningIcon,
        href: PATH_NAME.ASSIGNMENT_MASTER_LIST,
        label: DRAWER_MENU_LABEL.COMPLAINT_ASSIGNMENT,
      }, */
      {
        title: 'Complaint View',
        icon: ErrorIcon,
        href: PATH_NAME.COMPLAINT_VIEW_LIST,
        label: DRAWER_MENU_LABEL.COMPLAINT_VIEW,
      },
      {
        title: 'Events',
        icon: EventIcon,
        href: PATH_NAME.EVENT_LIST,
        label: DRAWER_MENU_LABEL.EVENT,
      },
      {
        title: 'Information / Guidelines',
        icon: AssignmentTurnedInIcon,
        href: PATH_NAME.INFORMATION_LIST,
        label: DRAWER_MENU_LABEL.INFORMATION,
      },
      {
        title: 'Schemes',
        icon: PolicyIcon,
        href: PATH_NAME.SCHEMES_LIST,
        label: DRAWER_MENU_LABEL.SCHEMES,
      },
      {
        title: 'Opportunities',
        icon: WorkIcon,
        href: PATH_NAME.OPPORTUNITY_LIST,
        label: DRAWER_MENU_LABEL.OPPORTUNITY,
      },
      {
        title: 'User Opportunities',
        icon: WorkIcon,
        href: PATH_NAME.USER_OPPORTUNITIES_LIST,
        label: DRAWER_MENU_LABEL.USER_OPPORTUNITIES,
      },
      {
        title: 'Resources',
        icon: FileCopyIcon,
        href: PATH_NAME.RESOURCES_LIST,
        label: DRAWER_MENU_LABEL.RESOURCES,
      },
      {
        title: 'Helplines',
        icon: ContactPhoneIcon,
        href: PATH_NAME.HELPLINES_LIST,
        label: DRAWER_MENU_LABEL.HELPLINES,
      },
      {
        title: 'Send Notification',
        icon: NotificationsIcon,
        href: PATH_NAME.NOTIFICATION_SEND,
        label: DRAWER_MENU_LABEL.NOTIFICATIONS,
      },
      // {
      //   title: 'Latest Update',
      //   icon: UpdateIcon,
      //   href: PATH_NAME.LATEST_UPDATE_LIST,
      //   label: DRAWER_MENU_LABEL.LATEST_UPDATE,
      // },
      // {
      //   title: 'Guidelines and Circulars',
      //   icon: ImportContactsIcon,
      //   href: PATH_NAME.GUIDELINES_AND_CIRCULARS_LIST,
      //   label: DRAWER_MENU_LABEL.GUIDELINES_CIRCULARS,
      // },
      // {
      //   title: 'Report',
      //   icon: PieChartIcon,
      //   href: PATH_NAME.COMPLAINT_ASSIGNMENT,
      //   label: DRAWER_MENU_LABEL.REPORT,
      //   items: [
      //     {
      //       title: 'Assignment Master',
      //       icon: RadioButtonUncheckedIcon,
      //       href: PATH_NAME.COMPLAINT_VIEW_LIST,
      //       label: DRAWER_MENU_LABEL.PRODUCT,
      //     },
      //   ],
      // },
      {
        title: 'Complaint Reassignment',
        icon: UpdateIcon,
        href: PATH_NAME.COMPLAINT_REASSIGNMENT_LIST,
        label: DRAWER_MENU_LABEL.COMPLAINT_REASSIGNMENT_LIST,
      },
      {
        title: 'Feedback',
        icon: Note,
        href: PATH_NAME.FEEDBACK_FORM,
        label: DRAWER_MENU_LABEL.FEEDBACK_FORM,
      },
    ],
  },
  // {
  //   subheader: 'Users',
  //   items: [
  //     {
  //       title: 'Users',
  //       icon: PeopleIcon,
  //       href: PATH_NAME.USERS,
  //       label: DRAWER_MENU_LABEL.USERS,
  //     },
  //   ],
  // },
];
